// @mui
import Box from '@mui/material/Box';
import { Stack, Typography, useTheme } from '@mui/material';

interface IProps {
	title: string;
	text?: string;
	color?: string;
	sx?: any;
	symbol?: string;
}

export const Paragraph1 = (props: IProps) => {
	return (
		<Box>
			<Typography variant="body2">{props.title}</Typography>
			{props.text && <Typography variant="body2">{props.text}</Typography>}
		</Box>
	);
};

export const Paragraph2 = (props: IProps) => {
	return (
		<Box color={props.color || 'inherit'}>
			<Typography variant="boldBody1">{props.title}</Typography>
			{props.text && <Typography variant="body1">{props.text}</Typography>}
		</Box>
	);
};

export const Paragraph3 = (props: IProps) => {
	return (
		<Box color={props.color || 'inherit'}>
			<Typography variant="boldBody1">{props.title}</Typography>
			{props.text && (
				<Typography fontFamily="RubikLight" variant="body1">
					{props.text}
				</Typography>
			)}
		</Box>
	);
};

export const Paragraph4 = (props: IProps) => {
	//menu item
	return (
		<Box color={props.color || 'inherit'}>
			<Typography variant="body2">{props.title}</Typography>
			{props.text && <Typography variant="caption">{props.text}</Typography>}
		</Box>
	);
};

export const Paragraph5 = (props: IProps) => {
	//small title big text
	return (
		<Box sx={props.sx} color={props.color || 'inherit'}>
			<Typography variant="semiCaptionRegular">{props.title}</Typography>
			{props.text && <Typography variant="body1">{props.text}</Typography>}
		</Box>
	);
};

export const Paragraph6 = (props: IProps) => {
	//same size 15px with bold header
	return (
		<Stack sx={props.sx} color={props.color || 'inherit'}>
			<Typography variant="boldMedium">{props.title}</Typography>
			{props.text && <Typography variant="body4">{props.text}</Typography>}
		</Stack>
	);
};

export const TableParagraph = (props: IProps) => {
	const theme = useTheme();
	return (
		<Stack sx={props.sx} color={props.color || 'inherit'}>
			<Typography variant="subtitle1">{props.title}</Typography>
			{props.text && (
				<Typography variant="caption" color={theme.palette.root.grey}>
					{props.text}
				</Typography>
			)}
		</Stack>
	);
};

export const FormReadonlyParagraph = (props: IProps) => {
	const theme = useTheme();
	return (
		<Stack sx={props.sx} color={props.color || 'inherit'}>
			<Typography variant="subtitle1">{props.title}</Typography>
			<Typography variant="subtitle2">{props.text}</Typography>
		</Stack>
	);
};

export const Paragraph5withBorder = (props: IProps) => {
	//input frame with symbol and small title big text
	return (
		<Stack
			direction="row"
			sx={{
				border: '1px solid #cbdcde',
				borderRadius: '8px',
				height: '54px',
				flexGrow: 1,
				alignItems: 'center',
			}}
		>
			<Typography variant="h3" sx={{ padding: '0 8px' }}>
				{props.symbol}
			</Typography>
			<Paragraph5 title={props.title} text={props.text} />
		</Stack>
	);
};
